import { from, of } from 'rxjs'
import { tap, pluck, filter, map, mapTo, catchError } from 'rxjs/operators'
import { termsText } from '@/helpers/terms'
import { updateTerms } from '@/service/company'
import { APP_MODAL_OPEN, SIMPLE } from '@/components/Modal/Enum'
import resources from '@/store/modules/resources/pt-BR.json'

export const verifyTerms = emit => notifications => {
  const emitModal = emit(APP_MODAL_OPEN)
  const emitTrack = emit('track')

  from([notifications])
    .pipe(
      pluck('terms', 'accepted'),
      filter(accepted => accepted === false),
      mapTo(termsText),
      map(terms => ({
        modal: SIMPLE,
        payload: {
          title: resources.general.termsAndPrivacy.payload.title,
          text: terms,
        },
        options: {
          okTitle: resources.general.termsAndPrivacy.payload.accept,
          okOnly: true,
          modalClass: 'terms-and-privacy',
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          hideHeaderClose: true,
        },
        on: {
          ok: modal => $event => {
            $event.preventDefault()
            updateTerms({ accepted: true })
              .pipe(
                tap(() => {
                  emitTrack({
                    event: 'Aceitou termos de uso',
                    data: {
                      category: 'App',
                    },
                  })
                  modal.hide()
                }),
                catchError(error => {
                  modal.$root.$emit(
                    'error',
                    `${
                      resources.general.termsAndPrivacy.payload.error
                    } ${error.toString()}`
                  )
                  return of({ error })
                })
              )
              .subscribe()
          },
        },
      })),
      tap(emitModal)
    )
    .subscribe()
}
